
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker } from '@/components';
import { useBonusLoginEdit } from '@/modules/bonus/login/model/edit';
import { timeUnits } from '@/common/utils/helpers';
import { BonusLoginType } from '@/modules/bonus/login/model/mixins';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';

export default defineComponent({
    name: ROUTE_NAME_BONUS.LOGIN.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, actions } = useBonusLoginEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, timeUnits, BonusLoginType };
    }
});
